/**
 * 科技汇
 */

import Container from '@/containers';

const mallRouter = {
    path: '/mall',
    component: Container,
    redirect: '/mall/demand',
    name: 'Mall',
    meta: {
        title: ''
    },
    children: [
        {
            path: 'demand/index',
            component: () => import('@/views/mall/demand/index'),
            name: 'MallDemandIndex',
            meta: {
                title: '需求大厅',
                showAddBtn:true
            }
        },
        {
            path: 'demand/contact',
            component: () => import('@/views/mall/demand/contact'),
            name: 'MallDemandContact',
            meta: {
                title: '提交联系方式'
            }
        },
        {
            path: 'demand',
            component: () => import('@/views/mall/demand/demand'),
            name: 'MallDemand',
            meta: {
                title: '问题库',
                showAddBtn:true
            }
        },
        {
            path: 'demand/detail',
            component: () => import('@/views/mall/demand/detail'),
            name: 'MallDemandDetail',
            meta: {
                title: '问题库详情',
                showAddBtn:true
            }
        },
        {
            path: 'demand/publish',
            component: () => import('@/views/mall/demand/publish'),
            name: 'MallDemandPublish',
            meta: {
                title: '发布需求'
            }
        },
        {
            path: 'achievement',
            component: () => import('@/views/mall/achievement/achievement'),
            name: 'MallAchievement',
            meta: {
                title: '项目库',
                showAddBtn:true
            }
        },
        {
            path: 'achievement/detail',
            component: () => import('@/views/mall/achievement/detail'),
            name: 'MallAchievementDetail',
            meta: {
                title: '项目库详情',
                showAddBtn:true
            }
        },
        {
            path: 'achievement/publish',
            component: () => import('@/views/mall/achievement/publish'),
            name: 'MallAchievementPublish',
            meta: {
                title: '发布成果'
            }
        },
        {
            path: 'talents',
            component: () => import('@/views/mall/talents'),
            name: 'MallTalents',
            meta: {
                title: '开源库',
                showAddBtn:true
            }
        }
    ]
};

export default mallRouter;